import { render, staticRenderFns } from "./Statistics.vue?vue&type=template&id=6e459927&scoped=true"
import script from "./Statistics.vue?vue&type=script&lang=js"
export * from "./Statistics.vue?vue&type=script&lang=js"
import style0 from "./Statistics.vue?vue&type=style&index=0&id=6e459927&prod&scoped=true&lang=css"
import style1 from "./Statistics.vue?vue&type=style&index=1&id=6e459927&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e459927",
  null
  
)

export default component.exports